import TabsCustom from '@/components/_common/TabsCustom';
import TextareaVars from '@/components/_common/TextareaVars';
import {
  Card,
  Form,
  Typography,
  Button,
  Statistic,
  FormListOperation,
  Divider,
  Badge,
} from 'antd';
import InvoiceCFEGeneralForm from '../GeneralForm';
import InvoiceCFETaxesForm from '../TaxesForm';
import { Group } from '@/components/_common';
import { useState } from 'react';
import StatusTag from '@/components/_common/StatusTag';
import {
  TaxCouponItemTypeLabel,
  TaxCouponItemType,
  TaxCouponItemTypeColor,
} from '@/core/domain/coupon/coupons/coupons.types';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  index: number;
  action: FormListOperation;
  tabError?: { general: boolean; taxes: boolean };
  isEdit: boolean;
}

const InvoiceCFEItemCard: React.FC<Props> = ({
  index,
  action,
  tabError,
  isEdit,
}) => {
  const form = Form.useFormInstance();
  const itemFields = Form.useWatch(['items', index], form);

  const [tab, setTab] = useState('general');

  return (
    <Card
      key={index}
      style={{ borderRadius: 8, marginBottom: 24 }}
      bodyStyle={{ padding: 12 }}
    >
      <Form.Item hidden name={[index, 'id']} />
      <Form.Item hidden name={[index, 'itemId']} />
      <Form.Item hidden name={[index, 'type']} />

      <Group position="between" style={{ marginBottom: 10 }}>
        <StatusTag
          label={TaxCouponItemTypeLabel[itemFields?.type as TaxCouponItemType]}
          color={TaxCouponItemTypeColor[itemFields?.type as TaxCouponItemType]}
        />

        <div>
          {!isEdit && (
            <Button
              size="small"
              type="ghost"
              danger
              shape="round"
              onClick={() => action.remove(index)}
            >
              Remover
            </Button>
          )}
        </div>
      </Group>

      <Typography.Title
        level={5}
        style={{ margin: 0 }}
        ellipsis
        title={itemFields?.description}
      >
        {itemFields?.description}
      </Typography.Title>

      <TabsCustom activeKey={tab} onChange={setTab}>
        <TabsCustom.Item
          key="general"
          label="Dados gerais"
          icon={tabError?.general ? <Badge dot /> : null}
        >
          <InvoiceCFEGeneralForm index={index} />
        </TabsCustom.Item>

        <TabsCustom.Item
          key="taxes"
          label="Tributos"
          icon={tabError?.taxes ? <Badge dot /> : null}
        >
          <InvoiceCFETaxesForm index={index} />
        </TabsCustom.Item>

        <TabsCustom.Item key="additionalInformation" label="Dados adicionais">
          <Form.Item name={[index, 'additionalInformation']}>
            <TextareaVars
              tags={[]}
              rows={10}
              selectProps={{ disabled: true }}
            />
          </Form.Item>
        </TabsCustom.Item>
      </TabsCustom>

      <Divider style={{ marginTop: 0 }} />

      <Group position="right">
        <Statistic
          title="Valor total"
          value={formatterPrice(
            itemFields?.quantity * (itemFields?.unitValue || 0) -
              (itemFields?.discount || 0) -
              (itemFields?.expenses || 0),
          )}
        />
      </Group>
    </Card>
  );
};

export default InvoiceCFEItemCard;
